<!--培训记录-->
<template lang="pug">
    <el-dialog title="培训记录" width="95%" :close-on-click-modal='false' :append-to-body="true" :visible.sync='visible' :modal-append-to-body='false'>
        <div class="container">
            <div>姓名:{{ objectParams.name }}</div>
            <div>账号:{{ objectParams.mobile }}</div>
            <div>身份证件:{{ objectParams.idCard }}</div>
            <div>性别:{{ objectParams.gender ? '女' : '男' }}</div>
            <div>参训次数:{{ objectParams.count || 0 }}</div>
            <div>总积分:{{ objectParams.point || 0 }}</div>
            <div>年度积分:{{ objectParams.yearScore || 0 }}</div>
            <div>季度积分:{{ objectParams.quarterScore || 0 }}</div>
        </div>
        el-form(:inline='true', :model='dataForm' size="mini" label-position='left' label-width="75px" label-suffix=':' )
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label='培训名称' )
                    el-input.inputWidth(v-model='dataForm.name' clearable='')
              el-col(:md='6' :sm="12")
                el-form-item(label='主办方')
                    el-select.inputWidth(v-model="dataForm.orgId" placeholder="请选择" filterable clearable)
                        el-option(v-for="(item,index) in sysOrgData" :key="index" :label="item.name" :value="item.orgId")
              el-col(:md='6' :sm="12")
                el-form-item(label='培训级别' )
                  el-select.inputWidth(v-model='dataForm.level' clearable placeholder="请选择培训级别" )
                      el-option(v-for="(e, i) in pxLevel" :key="i" :label="e.label" :value="e.value")
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label='培训类型')
                    el-select.inputWidth(v-model='dataForm.type' clearable placeholder="请选择培训类型" )
                        el-option(v-for="(e, i) in pxType2" :key="i" :label="e.label" :value="e.value")
              el-col(:md='6' :sm="12")
                el-form-item(label='培训时间' )
                    el-date-picker.inputWidth(style='width:210px;' v-model="dataForm.rangTime" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期")
              el-col(:md='12' :sm="12" style="text-align:right")
                 el-button(type='primary' icon="el-icon-search" @click="queryDataByParams") 查询
        el-table(:data="tableData" style="width: 100%" border)
            el-table-column(prop='businessId',header-align='center',align='center',label='培训ID' )
            el-table-column(prop='businessName',header-align='center',align='center',label='培训名称' )
            el-table-column(prop='orgName',header-align='center',align='center',label='主办方' )
            el-table-column(prop='typeName',header-align='center',align='center',label='培训类型' )
            el-table-column(prop='trainCount',header-align='center',align='center',label='参训次数' )
            el-table-column(prop='level',header-align='center',align='center',label='培训级别' )
            el-table-column(prop='startTime',header-align='center',align='center',label='培训开始时间' )
            el-table-column(prop='point',header-align='center',align='center',label='获得积分' )
            el-table-column(prop='coachName',header-align='center',align='center',label='教练' )
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 30]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">返回</el-button>
        </span> 
    </el-dialog>
</template>
<script>
import commonData from '@/pages/train/common.js'
export default {
    name: 'TraningRecorde',
    data () {
        return {
            pxLevel: commonData.pxLevel,
            pxType2: commonData.pxType2,
            visible: false,
            pageSize: 10,
            pageIndex: 1,
            tableData: [],
            totalPage: 0,
            memberId: '',
            objectParams: {},
            dataForm: {
                rangTime: [],
                endTime: '',
                level: '',
                name: '',
                orgId: '',
                strTime: '',
                type: ''
            }
        }
    },
    props: {
        sysOrgData: {
            default: () => [],
            type: Array
        }
    },
    methods: {
        // 根据条件查询数据
        queryDataByParams () {
            this.pageIndex = 1
            this.getGameDetailData()
        },
        init (id) {
            this.visible = true
            this.memberId = id
            this.getGameTotalData()
            this.getGameDetailData()
        },
         // 每页数
        sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getGameDetailData()
        },
        // 当前页
        currentChangeHandle (val) {
        this.pageIndex = val
        this.getGameDetailData()
        },
        // 获取培训统计信息
        getGameTotalData () {
            this.$http({
                url: this.$http.adornUrl(`/mbScore/trainPoint/${this.memberId}`),
                method: 'get'
            }).then(data => { 
                if (data && data.code === 0) {
                   this.objectParams = data.data
                }
            })
        },
        // 获取列表数据
        getGameDetailData () {
            let queryParams = Object.assign({ page: this.pageIndex, limit: this.pageSize }, this.dataForm)
            const [startTime = null, endTime = null] = this.dataForm.rangTime || []
            queryParams.strTime = startTime
            queryParams.endTime = endTime
            queryParams.rangTime = null
            this.$http({
                url: this.$http.adornUrl(`/mbScore/trainDetail/${this.memberId}`),
                method: 'get',
                params: this.$http.adornParams(
                    queryParams
                )
            }).then(data => { 
                if (data && data.code === 0) {
                    this.tableData = data.data.rows
                    this.totalPage = data.data.total
                } else {
                    this.tableData = []
                    this.totalPage = 0
                }
            })
        }
    }
}
</script>
<style scoped>
 .container {
    width: 80%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    flex-wrap: wrap;
 }
</style>